import api from '../api';

const guardianEmailPreferencesService = {
  getEmailPreferences: async () => {
    try {
      const response = await api.get('/guardian-email-preferences');
      return response.data;
    } catch (error) {
      console.error('Error in getEmailPreferences:', error);
      throw error;
    }
  },

  updateEmailPreferences: async (preferences) => {
    try {
      const response = await api.post(
        '/guardian-email-preferences',
        preferences
      );
      return response.data;
    } catch (error) {
      console.error('Error in updateEmailPreferences:', error);
      throw error;
    }
  },
};

export default guardianEmailPreferencesService;
